<template>
<div class="main">
  <Header></Header>
  <Context></Context>
</div>
</template>
<script>
import Header from "@/vms/pages/layout/Header"
import Context from "@/vms/pages/layout/Context"

export default {
  name: "Main",
  components: { Header, Context }
}
</script>
<style lang="sass" scoped>
  .main
    width: calc(100% - 200px)
    height: 100%
    margin-left: 200px
    overflow: hidden
</style>



// WEBPACK FOOTER //
// src/vms/pages/layout/Main.vue